import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { LocalDeviceDetectorService } from 'dmmp-services'

@Component({
  selector: 'dmmp-website-articles-featured',
  templateUrl: './website-articles-featured.component.html'
})
export class WebsiteArticlesFeaturedComponent implements OnInit {
  @Input() identifier
  @Input() data
  featureHome = []
  @Input() module
  @Output() page = new EventEmitter()
  constructor(public localDeviceDetector: LocalDeviceDetectorService) {
  }

  ngOnInit() {
    this.data.forEach(articleItem => {
      if (articleItem.featured_home) {
        this.featureHome.push(articleItem)
      }
    })
  }
}
